var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14900_11228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11922 4.79688L2.66016 4.1875V8.69031C2.66012 8.73925 2.66973 8.78772 2.68846 8.83294C2.70719 8.87815 2.73466 8.91922 2.7693 8.9538C2.80393 8.98838 2.84505 9.01578 2.8903 9.03443C2.93554 9.05309 2.98403 9.06262 3.03297 9.0625H9.00172C9.05071 9.06271 9.09926 9.05323 9.14458 9.03461C9.1899 9.016 9.23109 8.98861 9.2658 8.95402C9.3005 8.91944 9.32802 8.87834 9.34679 8.83308C9.36556 8.78782 9.3752 8.73931 9.37516 8.69031V7.03125L6.11922 4.79688Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11922 0.937501H3.03297C2.98403 0.937378 2.93554 0.946916 2.8903 0.965569C2.84505 0.984221 2.80393 1.01162 2.7693 1.0462C2.73466 1.08078 2.70719 1.12185 2.68846 1.16707C2.66973 1.21228 2.66012 1.26075 2.66016 1.30969V2.96875L6.11922 5L7.95078 5.60938L9.37516 5V2.96875L6.11922 0.937501Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66016 2.96875H6.11922V5H2.66016V2.96875Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.13578 2.5625H2.66016V7.64062H5.13578C5.23443 7.64013 5.32891 7.60079 5.39875 7.53113C5.46859 7.46146 5.50817 7.36708 5.50891 7.26844V2.93469C5.50817 2.83604 5.46859 2.74166 5.39875 2.672C5.32891 2.60233 5.23443 2.56299 5.13578 2.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.93234 2.76562H2.66016V7.84375H4.93234C5.03099 7.84326 5.12547 7.80392 5.19531 7.73425C5.26515 7.66459 5.30473 7.57021 5.30547 7.47156V3.13781C5.30473 3.03917 5.26515 2.94479 5.19531 2.87512C5.12547 2.80546 5.03099 2.76612 4.93234 2.76562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.93234 2.76562H2.66016V7.4375H4.93234C5.03099 7.43701 5.12547 7.39767 5.19531 7.328C5.26515 7.25834 5.30473 7.16396 5.30547 7.06531V3.13781C5.30473 3.03917 5.26515 2.94479 5.19531 2.87512C5.12547 2.80546 5.03099 2.76612 4.93234 2.76562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.72891 2.76562H2.66016V7.4375H4.72891C4.82755 7.43701 4.92203 7.39767 4.99187 7.328C5.06171 7.25834 5.10129 7.16396 5.10203 7.06531V3.13781C5.10129 3.03917 5.06171 2.94479 4.99187 2.87512C4.92203 2.80546 4.82755 2.76612 4.72891 2.76562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998125 2.76563H4.72875C4.82757 2.76554 4.92238 2.8047 4.99235 2.87449C5.06232 2.94428 5.10171 3.03899 5.10188 3.13781V6.86219C5.10171 6.96101 5.06232 7.05572 4.99235 7.12551C4.92238 7.1953 4.82757 7.23446 4.72875 7.23438H0.998125C0.949158 7.23454 0.900641 7.22503 0.855359 7.2064C0.810076 7.18777 0.768919 7.16037 0.734251 7.12579C0.699582 7.09121 0.672085 7.05012 0.653337 7.00489C0.634588 6.95965 0.624959 6.91116 0.625 6.86219V3.13781C0.624959 3.08885 0.634588 3.04035 0.653337 2.99512C0.672085 2.94988 0.699582 2.9088 0.734251 2.87421C0.768919 2.83963 0.810076 2.81224 0.855359 2.7936C0.900641 2.77497 0.949158 2.76546 0.998125 2.76563Z",
    fill: "url(#paint0_linear_14900_11228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 6.21066L2.56594 4.99691L1.84719 3.79004H2.42438L2.81656 4.56285C2.85281 4.63598 2.87906 4.69035 2.89094 4.7266H2.89625C2.92188 4.66806 2.94896 4.61118 2.9775 4.55598L3.39688 3.79129H3.92812L3.19094 4.99129L3.94688 6.2116H3.38156L2.92844 5.36441C2.90746 5.32796 2.88958 5.2898 2.875 5.25035H2.8675C2.85426 5.2888 2.83664 5.32561 2.815 5.36004L2.34844 6.21066H1.78125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 0.937502H6.11914V2.96875H9.37508V1.30969C9.37512 1.26072 9.36549 1.21223 9.34674 1.16699C9.32799 1.12176 9.3005 1.08067 9.26583 1.04609C9.23116 1.01151 9.19 0.984114 9.14472 0.965479C9.09944 0.946845 9.05092 0.937337 9.00195 0.937502Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11914 5H9.37508V7.03125H6.11914V5Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14900_11228",
    x1: 1.40438,
    y1: 2.47313,
    x2: 4.3225,
    y2: 7.52688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14900_11228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelSheet);
export default __webpack_public_path__ + "static/media/excelSheet.691f99a9162496f78eab32e5c6fd3890.svg";
export { ForwardRef as ReactComponent };